import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/common/brick-logo-filled.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/GetInTouch/hand-retrieving-power-bank.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/Social/facebook.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/Social/instagram.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/Social/linkedin.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web-home/src/app/[locale]/ScriptWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web-home/src/components/Header/DropdownMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web-home/src/components/Header/GetInTouchButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web-home/src/components/Header/HamburgerMenu.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/src/components/Header/LanguageDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web-home/src/components/Intercom/IntercomWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web-home/src/components/Intercom/LiveChatLoaderProviderWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/src/components/LinkWithQuery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-montserrat\"}],\"variableName\":\"montserrat\"}");
